import { BasePagedSearchCriteria } from "./BaseSearchCriteria";

export interface DeviceSearchCriteria extends BasePagedSearchCriteria{

    name?:string;
    
}

export const DEVICE_SEARCH_CRITERIA_KEY = 'DeviceSearchCriteria';